export * from 'misstime';
import { isNullOrUndefined, isArray, EMPTY_OBJ, isStringOrNumber, isObject, throwError, hasOwn, isString } from 'intact-shared';
export { EMPTY_OBJ, noop } from 'intact-shared';

function setTextModel(component, event) {
    var target = event.target;
    component.set(target.$M, target.value);
}
function setRadioModel(component, event) {
    var target = event.target;
    component.set(target.$M, getValue(target));
}
function setCheckboxModel(component, event) {
    var target = event.target;
    var modelName = target.$M;
    var checked = target.checked;
    var trueValue = target.$TV;
    var falseValue = target.$FV;
    var value = component.get(modelName);
    if (isNullOrUndefined(trueValue)) {
        trueValue = true;
    }
    if (isNullOrUndefined(falseValue)) {
        falseValue = false;
    }
    if (isArray(value)) {
        value = value.slice(0);
        var index = value.indexOf(trueValue);
        if (checked) {
            if (index === -1) {
                value.push(trueValue);
            }
        }
        else {
            if (index > -1) {
                value.splice(index, 1);
            }
        }
    }
    else {
        value = checked ? trueValue : falseValue;
    }
    component.set(modelName, value);
}
function isChecked(value, trueValue) {
    if (isArray(value)) {
        return value.indexOf(trueValue) > -1;
    }
    else {
        return value === trueValue;
    }
}
function setSelectModel(component, event) {
    var target = event.target;
    var multiple = target.multiple;
    var options = target.options;
    var value;
    if (multiple) {
        value = [];
        for (var i = 0; i < options.length; i++) {
            var opt = options[i];
            if (opt.selected) {
                value.push(getValue(opt));
            }
        }
    }
    else {
        for (var i = 0; i < options.length; i++) {
            var opt = options[i];
            if (opt.selected) {
                value = getValue(opt);
                break;
            }
        }
    }
    component.set(target.$M, value);
}
function getValue(el) {
    var value = el.$VA;
    return isNullOrUndefined(value) ? el.value : value;
}
function extend(source, extra) {
    if (extra === EMPTY_OBJ)
        return source;
    for (var key in extra) {
        source[key] = extra[key];
    }
    return source;
}
function className(obj) {
    if (isNullOrUndefined(obj))
        return null;
    if (isStringOrNumber(obj))
        return obj;
    var ret = [];
    for (var key in obj) {
        if (obj[key]) {
            ret.push(key);
        }
    }
    return ret.join(' ');
}
function map(data, iter, thisArg) {
    if (isNullOrUndefined(data))
        return;
    if (isObject(data)) {
        var ret_1 = [];
        var callback = function (value, key) {
            var result = iter.call(thisArg, value, key);
            if (isArray(result)) {
                ret_1.push.apply(ret_1, result);
            }
            else {
                ret_1.push(result);
            }
        };
        if (data.forEach) {
            data.forEach(callback);
        }
        else if (isArray(data)) {
            /* istanbul ignore next */
            for (var i = 0; i < data.length; i++) {
                callback(data[i], i);
            }
        }
        else {
            for (var key in data) {
                callback(data[key], key);
            }
        }
        return ret_1;
    }
    if (process.env.NODE_ENV !== 'production') {
        throwError("Cannot handle ".concat(JSON.stringify(data), " for v-for."));
    }
}
var getPrototypeOf = Object.getPrototypeOf;
function superCall(props, blocks, __proto__) {
    if (!__proto__) {
        __proto__ = getPrototypeOf(this);
        while (!hasOwn.call(__proto__.constructor, 'template')) {
            // if the component has not template, then get the parent's template
            __proto__ = getPrototypeOf(__proto__);
        }
        __proto__ = getPrototypeOf(__proto__);
    }
    while (!hasOwn.call(__proto__.constructor, 'template')) {
        // if the super component has no template, then get super's super's template
        __proto__ = getPrototypeOf(__proto__);
    }
    var superTemplate = __proto__.constructor.template;
    if (isString(superTemplate)) {
        superTemplate = compile(superTemplate);
    }
    return superTemplate.call(this, props, blocks, getPrototypeOf(__proto__));
}
var compile;
function registerCompile(_compile) {
    compile = _compile;
}

export { className, compile, extend, isChecked, map, registerCompile, setCheckboxModel, setRadioModel, setSelectModel, setTextModel, superCall };
